import { render, staticRenderFns } from "./MinistriesPage.vue?vue&type=template&id=09a3f71c&"
import script from "./MinistriesPage.vue?vue&type=script&lang=js&"
export * from "./MinistriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports